// import ApiService from '@/helpers/api.service';
// const API = new ApiService();
import ApiService2 from "@/helpers/api.service.v6lite";
const APIV6 = new ApiService2();
const ELOAD_MAINTENANCE_ENDPOINT = "/eload/maintenance";

export const state = {
  eloadMaintenanceList: [],
  eloadMaintenanceTotal: 0,
  eloadMaintenanceDetails: {},
  eloadMaintenanceLogs: [],
  eloadMaintenanceLogsTotal: 0,
  eloadLogsCreatedBy: "",
  eloadLogsCreatedAt: "",
  eloadMaintenanceProvider: [],
  eloadMaintenanceNetwork: [],
  eloadMaintenanceNetworkGroup: [],
  errors: null,
};

export const mutations = {
  UPDATE_ELOAD_MAINTENANCE_LIST(state, value) {
    state.eloadMaintenanceList = value;
  },
  UPDATE_ELOAD_MAINTENANCE_TOTAL(state, total) {
    state.eloadMaintenanceTotal = total;
  },
  UPDATE_ELOAD_MAINTENANCE_DETAILS(state, value) {
    state.eloadMaintenanceDetails = value;
  },
  UPDATE_ELOAD_MAINTENANCE_LOGS(state, value) {
    state.eloadMaintenanceLogs = value;
  },
  UPDATE_ELOAD_MAINTENANCE_LOGS_TOTAL(state, total) {
    state.eloadMaintenanceLogsTotal = total;
  },
  UPDATE_ELOAD_LOGS_TOTAL_CREATED(state, value) {
    state.eloadLogsCreatedBy = value.createdBy;
    state.eloadLogsCreatedAt = value.createdAt;
  },
  UPDATE_ELOAD_MAINTENANCE_OPTIONS(state, value) {
    state.eloadMaintenanceProvider = value.provider;
    state.eloadMaintenanceNetwork = value.network;
    state.eloadMaintenanceNetworkGroup = value.network_group;
  },
  SET_PROD_ERRORS(state, errors) {
    state.errors = errors;
  },
};

export const actions = {
  getEloadMaintenanceList(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`${ELOAD_MAINTENANCE_ENDPOINT}/list-maintenance`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_MAINTENANCE_LIST", data.message.rows);
          context.commit("UPDATE_ELOAD_MAINTENANCE_TOTAL", data.message.pageInfo.total);
          if (params?.includeAuthor) {
            context.commit("UPDATE_ELOAD_LOGS_TOTAL_CREATED", { 
              createdBy: data.message.rows[0].created_by, 
              createdAt: data.message.rows[0].created_at
            });
          }
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  getEloadMaintenanceDetails(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`${ELOAD_MAINTENANCE_ENDPOINT}/maintenance-details`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_MAINTENANCE_DETAILS", data.message.request);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  async saveEloadMaintenance(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`${ELOAD_MAINTENANCE_ENDPOINT}/save-maintenance`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  async updateEloadMaintenance(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`${ELOAD_MAINTENANCE_ENDPOINT}/update-maintenance`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  async getEloadMaintenanceLogs(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`${ELOAD_MAINTENANCE_ENDPOINT}/maintenance-logs`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_MAINTENANCE_LOGS", data.message.rows);
          context.commit("UPDATE_ELOAD_MAINTENANCE_LOGS_TOTAL", data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  async getEloadMaintenanceOptions(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`${ELOAD_MAINTENANCE_ENDPOINT}/get-maintenance-options`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_MAINTENANCE_OPTIONS", data.message);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  async actionEloadMaintenance(context, { params, action }) {
    return new Promise((resolve, reject) => {
      APIV6.post(`${ELOAD_MAINTENANCE_ENDPOINT}/${action}`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  async cancelEloadMaintenance(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`${ELOAD_MAINTENANCE_ENDPOINT}/cancel-maintenance`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  async getEloadMaintenanceAuditLogs(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`${ELOAD_MAINTENANCE_ENDPOINT}/list-maintenance-audit-logs`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_MAINTENANCE_LOGS", data.message.rows);
          context.commit("UPDATE_ELOAD_MAINTENANCE_LOGS_TOTAL", data.message.pageInfo.total);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  async exportEloadMaintenanceAuditLogs(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`${ELOAD_MAINTENANCE_ENDPOINT}/export-maintenance-audit-logs`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  }
};
